export const CompetenceOrderDecisionBehaviorCodes = {
  WithoutReason: 'WITHOUTREASON',
  WithReason: 'WITHREASON',
  OnlyOneReason: 'ONLYONEREASON'
};
